import { memo, useCallback } from 'react';
import { useTranslation } from '@betty/i18n';
import { useNavigation, StackNavigationProp } from '@betty/navigation';
import { Box, Button, InfoImage } from '@betty/moonlight';
import { PaymentMethodVerificationRequiredProps } from './PaymentMethodVerificationRequired.types';

function PaymentMethodVerificationRequired({
  paymentEntityId,
  transactionType,
}: PaymentMethodVerificationRequiredProps) {
  const { t } = useTranslation('wallet');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const context = { context: transactionType.toLowerCase() };

  const onPress = useCallback(() => {
    navigation.navigate('PaymentMethodVerification', { paymentEntityId });
  }, [paymentEntityId, navigation]);

  return (
    <InfoImage
      flex={1}
      image="wallet.shield"
      title={t('paymentMethodVerificationRequiredTitle', context)}
      description={t('paymentMethodVerificationRequiredDescription', context)}
    >
      <Box flex={1} justifyContent="flex-end" gap="space-400">
        <Button
          text={t('paymentMethodVerificationRequiredButton', context)}
          size="large"
          width="100%"
          onPress={onPress}
        />
        <Button
          variant="secondary"
          locNS="common"
          locKey="goBack"
          size="large"
          width="100%"
          onPress={navigation.goBack}
        />
      </Box>
    </InfoImage>
  );
}

export default memo(PaymentMethodVerificationRequired);
